import styled from 'styled-components';
import Button from 'carbon-react/esm/components/button/__next__';

const BilanIconButton = styled(Button)`
  box-sizing: border-box;
  flex: 0 0 var(--global-size-xs);
  width: var(--global-size-xs);
  min-width: var(--global-size-xs);
  max-width: var(--global-size-xs);
  height: var(--global-size-xs);
  min-height: var(--global-size-xs);
  max-height: var(--global-size-xs);
  padding: 0;
  border-radius: var(--global-radius-action-circle);
`;

export default BilanIconButton;
